import { IntroIFrame, IntroWrapper } from '../__intro-elements';
import { IntroKeys } from '../intro-keys';

const StoryboardTrack1 = () => (
  <IntroWrapper>
    <p>
      Welcome to the <b>Storyboard Track</b>! This is where you'll arrange your clips to tell your story.
    </p>
  </IntroWrapper>
);

const StoryboardTrack2 = () => (
  <IntroWrapper size="medium">
    <p>
      The <b>Storyboard Track</b> is the heart of your video editing workflow. Here you can:
    </p>
    <ul>
      {/* TODO: Add this back when drag and drop from Highlights is implemented */}
      {/* <li>Drag and drop clips from the Highlights page</li> */}
      <li>Rearrange clips to change the story flow</li>
      <li>Preview your story before rendering</li>
      <li>Fine-tune clip timing and effects</li>
    </ul>
  </IntroWrapper>
);

const StoryboardTrack3 = () => (
  <IntroWrapper size="medium">
    <p>
      <b>Zoom:</b> Initially, the Storyboard is zoomed out to show the entire timeline. Clips will be stacked on top of
      each other and difficult to see.
    </p>
    <p>
      Use your <b>mouse wheel</b> or <b>touch pad</b> to zoom into the track. This will make it easier to manage and
      configure your clips.
    </p>
    <p>
      <i>Give it a try!</i>
    </p>
    <IntroIFrame src="https://www.youtube.com/embed/TTnMuFBKB8U" />
  </IntroWrapper>
);

const StoryboardTrack4 = () => (
  <IntroWrapper size="medium">
    <p>
      <b>Track Management:</b> Use the other tracks to help organize your workflow:
    </p>
    <ul>
      <li>
        <b>Clipboard Track:</b> Stage clips before adding them to your story
      </li>
      <li>
        <b>Discardboard Track:</b> This is the cutting room floor - store clips here that you're not ready to delete
      </li>
    </ul>
    <p>Click the track headers to expand or collapse them, and use Ctrl+click to expand/collapse any single track.</p>
  </IntroWrapper>
);

const StoryboardTrack5 = () => (
  <IntroWrapper>
    <p>
      <b>Ready to render?</b> When you're satisfied with your storyboard, click the "Render" button to create your final
      montage. It will be sent to the <b>Render Queue</b> to be processed.
    </p>
    <p>Don't worry - you can always come back and make changes, then re-render as many times as you like!</p>
  </IntroWrapper>
);

export const TUTS_SB_TRACK = [
  { element: `[data-intro="${IntroKeys.storyBoardHeader}"]`, intro: <StoryboardTrack1 /> },
  { element: `[data-intro="${IntroKeys.storyBoardHeader}"]`, intro: <StoryboardTrack2 /> },
  { element: `[data-intro="${IntroKeys.storyBoardHeader}"]`, intro: <StoryboardTrack3 /> },
  { element: `[data-intro="${IntroKeys.storyBoardHeader}"]`, intro: <StoryboardTrack4 /> },
  { element: `[data-intro="${IntroKeys.storyBoardHeader}"]`, intro: <StoryboardTrack5 /> },
];
